const React = require("react");
const PropTypes = require("prop-types");
const classNames = require("classnames");

class Button extends React.PureComponent {
  render() {
    const {
      domRef,
      disabled,
      inverse,
      primary,
      small,
      submit,
      children,
      onClick,
      classOverride,
    } = this.props;

    const className = classOverride !== undefined
      ? classOverride
      : classNames(
        "b-button",
        disabled && "b-button--disabled",
        inverse && "b-button--inverse",
        !primary && "b-button--grey",
        small && "b-button--small",
        submit && "b-button--submit",
      );

    return (
      <button
        ref={domRef}
        disabled={disabled}
        onClick={onClick}
        type="button"
        className={className}
        style={{
          width: !submit && "100%",
          margin: 0,
        }}
      >
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  domRef: PropTypes.bool,
  disabled: PropTypes.bool,
  inverse: PropTypes.bool,
  primary: PropTypes.bool,
  small: PropTypes.bool,
  submit: PropTypes.bool,
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  classOverride: PropTypes.string,
};

Button.defaultProps = {
  domRef: undefined,
  disabled: false,
  inverse: false,
  primary: false,
  small: false,
  submit: false,
  onClick: () => {},
  classOverride: undefined,
};

module.exports = Button;
